import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
  Label,
} from "reactstrap";
import { deleteMenu } from "redux/actions/Screening/screeningActions";
import { connect } from "react-redux";
import _ from "lodash";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);

const DeletarMenu = (props) => {
  // ** Const
  // ** Props
  const { open, setOpen } = props;
  const [menu, setMenu] = useState({
    nome: "",
  });
  const [menus, setMenus] = useState([]);

  useEffect(() => {
    if (props.editMenu) window.location.reload();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.editMenu]);

  useEffect(() => {
    //setMenu({ nome: localStorage.getItem("menu_completo")?.replace(/\//g,"|") });
    setMenus(
      _.sortBy(
        JSON.parse(localStorage.getItem("menus"))?.filter(
          (item) => item.area === localStorage.getItem("area")
        ),
        (item) => item.menu
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("menus")]);

  const handleDelete = () => {
    
    MySwal.fire({
      title: "Deletar?",
      text: `Tem certeza que gostaria de excluir o menu ${menu.nome}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Deletar",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-outline-primary ml-1",
      },
      buttonsStyling: false,
      showLoaderOnConfirm: true,
    }).then(function (result) {
      if (result.value) {
        let area = localStorage.getItem("area");
        let model = {
          params: {
            arg1: area,
            arg2: menu.nome,
          },
        };
        props.deleteMenu(model);
        setOpen(false);
      }
    });
  };

  const handleSelectMenu = (item) => {
    setMenu({ nome: item.menu });
  };

  return (
    <Modal
      isOpen={open}
      toggle={() => setOpen(!open)}
      className={`modal-dialog-centered`}
      size="lg"
    >
      <ModalHeader toggle={() => setOpen(!open)}>Deletar Menu </ModalHeader>
      <ModalBody>
        <Form id="form" className="mb-1">
          <h5>Selecione o Menu</h5>
          {menus.map((item) => (
            <div className="form-check-radio">
              <Label check>
                <Input
                  defaultValue="option1"
                  id="exampleRadios11"
                  name="exampleRadioz"
                  type="radio"
                  onClick={() => handleSelectMenu(item)}
                />
                {item.menu} <span className="form-check-sign" />
              </Label>
            </div>
          ))}
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button type="submit" onClick={(e) => handleDelete(e)} color="primary">
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    publish: state.screening.screening.publish,
    menuNew: state.screening.screening.menuNew,
    editMenu: state.screening.screening.editMenu,
    //e/rror: state.screening.screening.error,
    //loading: state.screening.screening.loading,
  };
};

export default connect(mapStateToProps, {
  deleteMenu,
})(DeletarMenu);
